import dayjs from 'dayjs';
import { SSR_safe_mq_breakpointIsMobile } from '@/injectionSymbols';

export function useDatePicker(
  props: { modelValue: [Date, Date]; mode: 'all' | 'future' | 'past' },
  emit: (event: 'update:modelValue', value: [Date, Date]) => void,
) {
  const isMobile = inject(SSR_safe_mq_breakpointIsMobile);
  const { t } = useTrans();

  const settings = {
    locale: 'de',
    weekNumName: t('calendar.labels.cw'),
    monthNameFormat: 'long',
    position: 'left',
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    altPosition: (el: HTMLElement | undefined) => ({
      top: '0',
      left: '0',
      transform: 'none',
    }),
    range: false,
    presetRanges: getPresetRanges(),
    format: (date: Date) => dayjs(date).format('DD.MM.YYYY'),
    enableTimePicker: false,
    autoApply: true,
  };

  const datepicker1 = ref(null);
  const datepicker2 = ref(null);

  const date = ref<[Date, Date]>(
    props.modelValue ? props.modelValue : [dayjs().toDate(), dayjs().toDate()],
  );
  watch(
    () => props.modelValue,
    (newValue) => {
      if (newValue[0] !== date.value[0]) date.value[0] = newValue[0];
      if (newValue[1] !== date.value[1]) date.value[1] = newValue[1];
    },
  );

  function setRange(range: Date[]) {
    date.value[0] = range[0];
    date.value[1] = range[1];
    datepicker1.value.closeMenu();
    datepicker2.value.closeMenu();
  }

  function onDatepickerClosed() {
    emit('update:modelValue', date.value);
  }

  function getPresetRanges() {
    const today = {
      label: t('calendar.presetRanges.today'),
      value: [dayjs().toDate(), dayjs().toDate()],
      slot: 'preset-button',
    };

    if (props.mode === 'future')
      return [
        today,
        {
          label: t('calendar.presetRanges.nextWeek'),
          value: [dayjs().toDate(), dayjs().add(7, 'day').toDate()],
          slot: 'none',
        },
        {
          label: t('calendar.presetRanges.nextMonth'),
          value: [dayjs().toDate(), dayjs().add(30, 'day').toDate()],
          slot: 'none',
        },
        {
          label: t('calendar.presetRanges.unlimited'),
          value: [dayjs().toDate(), null],
          slot: 'none',
        },
      ];
    if (props.mode === 'past')
      return [
        today,
        {
          label: t('calendar.presetRanges.lastWeek'),
          value: [dayjs().subtract(7, 'day').toDate(), dayjs().toDate()],
          slot: 'none',
        },
        {
          label: t('calendar.presetRanges.lastMonth'),
          value: [dayjs().subtract(30, 'day').toDate(), dayjs().toDate()],
          slot: 'none',
        },
        {
          label: t('calendar.presetRanges.unlimited'),
          value: [null, dayjs().toDate()],
          slot: 'none',
        },
      ];
    return [];
  }
  return {
    isMobile,
    settings,
    datepicker1,
    datepicker2,
    date,
    setRange,
    onDatepickerClosed,
  };
}
